export class RtfImageInfo {
}
export class RelativeRect {
}
